import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-slate-50" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
      <Helmet>
        <title>Syarat &amp; Ketentuan — RencanaGuru.com</title>
        <meta name="description" content="Syarat dan ketentuan penggunaan layanan RencanaGuru.com, platform AI pembuatan Modul Ajar untuk guru Indonesia." />
        <link rel="canonical" href="https://rencanaguru.com/terms-of-service" />
      </Helmet>
      {/* Header */}
      <div className="bg-white border-b border-slate-200 px-6 py-4">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="/logo.png" alt="RencanaGuru" className="h-8 w-8 object-contain" />
            <span className="font-bold text-lg text-blue-700" style={{ fontFamily: "'Outfit', sans-serif" }}>
              RencanaGuru<span className="text-yellow-500">.com</span>
            </span>
          </Link>
          <Link to="/login" className="text-sm text-blue-600 hover:underline">Kembali ke Login</Link>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-slate-800 mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Syarat & Ketentuan
        </h1>
        <p className="text-sm text-slate-400 mb-10">Terakhir diperbarui: 17 Juni 2026</p>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-8 space-y-8 text-slate-600 leading-relaxed">

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">1. Penerimaan Syarat</h2>
            <p>Dengan mendaftar dan menggunakan layanan RencanaGuru.com, Anda menyatakan telah membaca, memahami, dan menyetujui syarat dan ketentuan ini. Jika Anda tidak setuju, mohon untuk tidak menggunakan layanan kami.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">2. Deskripsi Layanan</h2>
            <p>RencanaGuru.com adalah platform berbasis AI yang membantu guru Indonesia membuat perangkat pembelajaran seperti Modul Ajar, KKTP, Promes, Prota, dan dokumen pendidikan lainnya secara otomatis dan efisien.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">3. Akun Pengguna</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>Anda bertanggung jawab menjaga kerahasiaan password akun Anda</li>
              <li>Satu akun hanya boleh digunakan oleh satu orang</li>
              <li>Anda bertanggung jawab atas semua aktivitas yang terjadi di akun Anda</li>
              <li>Kami berhak menonaktifkan akun yang melanggar ketentuan ini</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">4. Sistem Koin Guru</h2>
            <p>Koin Guru adalah kredit virtual yang digunakan untuk mengakses fitur pembuatan dokumen. Koin yang sudah dibeli tidak dapat dikembalikan (non-refundable) kecuali terdapat kesalahan teknis dari pihak kami. Koin tidak memiliki nilai tukar mata uang.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">5. Penggunaan yang Dilarang</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>Menggunakan layanan untuk tujuan ilegal atau tidak etis</li>
              <li>Menyebarkan konten yang melanggar hak cipta orang lain</li>
              <li>Mencoba meretas atau mengganggu sistem kami</li>
              <li>Menjual kembali akses layanan kepada pihak lain</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">6. Hak Kekayaan Intelektual</h2>
            <p>Dokumen yang Anda hasilkan menggunakan platform kami adalah milik Anda sepenuhnya. Platform, desain, dan teknologi RencanaGuru.com adalah milik kami dan dilindungi oleh hak cipta.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">7. Perubahan Layanan</h2>
            <p>Kami berhak mengubah, menangguhkan, atau menghentikan layanan kapan saja dengan pemberitahuan yang wajar. Perubahan harga akan diinformasikan setidaknya 7 hari sebelumnya.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 mb-3">8. Kontak</h2>
            <p>Pertanyaan terkait syarat dan ketentuan dapat dikirimkan ke <a href="mailto:support@rencanaguru.com" className="text-blue-600 hover:underline">support@rencanaguru.com</a>.</p>
          </section>

        </div>
      </div>
    </div>
  );
};
